import React, { Component } from 'react';
import './Loader.css';

export default class Loader extends Component {

  constructor() {
    super();
    this.state = { hidden: true };
    window.page.loader = this;
  }

  show() {
    this.setState({ hidden: false });
  }

  hide() {
    this.setState({ hidden: true });
  }
  
  render() {
    return (
      <div className={ this.state.hidden ? "hidden" : "loader" }></div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/Loader.js